import {Box, Typography} from '@mui/material';
import ArchiveBox from "@/src/components/journal-site/archive/mui-custom/archive-box/archive-box";
import ArchiveTitleBox from "@/src/components/journal-site/archive/mui-custom/archive-title-box/archive-title-box";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBookOpenCover} from "@fortawesome/pro-duotone-svg-icons";
import ArchiveTitleText from "@/src/components/journal-site/archive/mui-custom/archive-title-text/archive-title-text";
import CardTitleDivider from "@/src/mui-custom/card/card-title-divider/card-title-divider";
import ArchiveTitleContainer
    from "@/src/components/journal-site/archive/mui-custom/archive-title-container/archive-title-container";
import IssueItem from "@/src/components/journal-site/archive/issues/issue/issue";
import IssueActiveBox from "@/src/components/journal-site/archive/issues/mui-custom/issue-active-box/issue-active-box";
import IssueActiveText
    from "@/src/components/journal-site/archive/issues/mui-custom/issue-active-text/issue-active-text";
import IssuesProps from "@/src/_types/Archive/issue-props";

const Issues = (props: IssuesProps) => {
    const filteredIssues = props.selectedVolume
        ? props.issues?.filter(
            (issue) => issue.volume_id === props.selectedVolume.volume_id
        )
        : [];

    return (
        <ArchiveBox>
            <ArchiveTitleContainer>
                <ArchiveTitleBox>
                    <FontAwesomeIcon icon={faBookOpenCover} className={'icon'}/>
                    <ArchiveTitleText variant={"h4"}>
                        issues
                    </ArchiveTitleText>
                </ArchiveTitleBox>
                <CardTitleDivider/>
            </ArchiveTitleContainer>

            <Box sx={{
                marginTop: '1.5rem',
            }}>
                {filteredIssues.length > 0 ? (
                    <>
                        {filteredIssues.map((issue, index) => (
                            <Box key={index} sx={{marginBottom: '1.25rem'}}>
                                {index === 0 && (
                                    <IssueActiveBox>
                                        <IssueActiveText>
                                            {`VOLUME ${props.selectedVolume.volume_name}`}
                                        </IssueActiveText>
                                        {!issue.url && (
                                            <IssueActiveText>
                                                <Typography component="span" className={'green'}>
                                                    {filteredIssues.length}
                                                </Typography>
                                                <Typography component="span">Issue(s)</Typography>
                                            </IssueActiveText>
                                        )}
                                    </IssueActiveBox>
                                )}
                            </Box>
                        ))}

                        {filteredIssues.map((issue, index) =>
                            <IssueItem
                                key={index}
                                issue={issue}
                            />
                        )}
                    </>
                ) : (
                    <Typography>{'No Issues found for this volume-item.'}</Typography>
                )}
            </Box>
        </ArchiveBox>
    );
};

export default Issues;
